import React, { memo, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    StyledButtonBlock,
    UploadAndDownoadButtons,
    PopoverWrapper,
    PopoverContent,
    FlexCol,
    Title,
    Description,
    DownloadButton,
    Wrapper,
    StyledIcon
} from './styles';
import { requestInProcess } from 'selectors';
import { useSelector } from 'react-redux';

const UploadDownloadSection = memo(({
    onDownloadTemplateClicked,
    setUploadButtonClicked
}) => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const isLoading = useSelector(state => requestInProcess(state, "SCHEDULES_IMPORT"))

    const handleUploadClick = useCallback(() => {
        setUploadButtonClicked(true);
    }, []);

    const togglePopover = useCallback(() => {
        setPopoverVisible(prev => !prev);
    }, []);

    const handleDownloadClick = useCallback(() => {
        onDownloadTemplateClicked();
        setPopoverVisible(false);
    }, [onDownloadTemplateClicked]);

    return (
        <StyledButtonBlock>
            <UploadAndDownoadButtons disabled={isLoading} onClick={handleUploadClick}>
                <Wrapper><StyledIcon icon='upload' /> {isLoading ? 'Uploading...' : 'Upload Data'}</Wrapper>
            </UploadAndDownoadButtons>

            <UploadAndDownoadButtons onClick={togglePopover}>
                <Wrapper><StyledIcon icon='downloadIcon' />Download our Template</Wrapper>
            </UploadAndDownoadButtons>

            {popoverVisible && (
                <PopoverWrapper>
                    <PopoverContent tabIndex={-1} role="dialog">
                        <FlexCol>
                            <Title>Excel Template</Title>
                            <Description>
                                Download our pre-formatted Excel template to ensure your data is properly structured.
                            </Description>
                            <DownloadButton onClick={handleDownloadClick}>
                                Download Template
                            </DownloadButton>
                        </FlexCol>
                    </PopoverContent>
                </PopoverWrapper>
            )}
        </StyledButtonBlock>
    );
});


UploadDownloadSection.displayName = 'UploadDownloadSection';

UploadDownloadSection.propTypes = {
    onUploadTemplate: PropTypes.func.isRequired,
    onDownloadTemplateClicked: PropTypes.func.isRequired,
};

export default UploadDownloadSection;
